import INVOICE_INPUT_IDS from './invoiceInputs';

const INPUT_IDS = {
  // basic information
  ID: 'id',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  EMAIL: 'email',
  PHONE: 'phone',
  DATE: 'birthday',

  // invoice data
  ...INVOICE_INPUT_IDS,

  // agreements
  EMAIL_CONSENT: 'emailConsent',
  SMS_CONSENT: 'smsConsent',
  PHONE_CONSENT: 'phoneConsent',
  SERVICE_AGREEMENT: 'serviceTerms',
} as const;

export default INPUT_IDS;
